import React from 'react'
import { ContextLayoutModels } from './ContextLayout'

export default function ContextContainer(props: any) {

    return (
        <>
                <ContextLayoutModels>
                    {props.children}
                </ContextLayoutModels>
        </>
    )
}